module.exports = __webpack_public_path__ + "static/img/landscape.fdee267.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/mobile/landscape.jpg
// module id = 669
// module chunks = 64